angular.module('aprima-legacy-common').filter('apPatientThumbnailSrc', [function () {
    'use strict';
    return function (patientId, height, width) {
        if(!patientId) {
            // if the patientId is null or undefined, return undefined because a valid url can't be formed
            // and undefined can be handled accordingly
            return;
        }

        if(height && !width) {
            width = height;
        }

        var url = 'patients/' + patientId + '/thumbnail';

        if(height) {
            url += '?height=' + height + '&width=' + width;
        }

        return url;
    };
}]);
